<template>
  <div class="AssetCategoryReg flex-column">
    <div class="detail-container flex-fixed flex">      
      <div class="flex-column flex-fixed column" style="width: 500px;">
        <AssetCategoryTable
          title="주계정"
          :items="category1Items"
          :nameWidth="150"
          :has_grant_write="has_grant_write"
          @select="handleSelect"
          @register="handleRegister"
          @delete="handleDelete"
        />
      </div>
      <div class="flex-column flex-auto column">
        <AssetCategoryTable
          title="부계정"
          :items="category2Items"
          :disable_insert="!category1"
          :parent="category1"
          :has_grant_write="has_grant_write"
          @register="handleRegister"
          @delete="handleDelete"
        />
      </div>      
    </div>    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";
import AssetCategoryTable from "./AssetCategoryTable"

export default {
  name: "AssetCategoryReg",
  mixins: [base_data],
  components: {AssetCategoryTable},
  data() {
    return {
      title: this.$t("title.asset_category"),
      items: [],
      category1: null,
      base_data: ['table_asset_category']
    }    
  },  
  props: {
    type_id: {
      type: Number,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_asset_category"]),
    category1Items: function() {  
      return this.items.filter(
        c => c.type_id === this.type_id && !c.parent_id);
    },
    category2Items: function() {
      if (!this.category1) { return []; }
      let items = this.items.filter(
        c => c.type_id === this.type_id && c.parent_id === this.category1.id);
      return items;
    },
  }, 
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.items = Object.assign([], this.table_asset_category);
    },
    handleSelect(data) {
      this.category1 = data;
    },
    handleRegister(data) {      
      if (data.id) {
        this.api.updateAssetCategory(data).then(res => {
          this.handleResponse(res, this.$t('message.success_update'));
        });
      } else {
        data.type_id = this.type_id;
        this.api.createAssetCategory(data).then(res => {
          this.handleResponse(res, this.$t('message.success_create'));
        });
      }
    },
    handleDelete(data) {
      this.api.deleteAssetCategory(data).then(res => {
        this.handleResponse(res, this.$t('message.success_delete'));
      });
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
    },
  },
}
</script>

<style lang="scss" scoped>
.column { 
  width: 49%;
  &:not(:last-child) {
    margin-right: 20px;
  }
}
</style>